<template>
  <div>
    <section class="main no-flex">
      <div
        class=""
      >

        <OrdersListt
          :create-order="true"
          @sendON="getON"
        />
        <!-- <ArticleListingg
          :order-id="orderNumber"
          :create-order="true"
        /> -->
      </div>
    </section>

  </div></template>

<script>
import OrdersListt from '@/components/productsInStock/ProductsListInStock.vue'
// import ArticleListingg from '@/components/productsInStock/AssignTeamInProductList.vue'
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {
    OrdersListt,
    // ArticleListingg,
  },
  data() {
    return {
      orderNumber: '',
      productMatObj: {},
    }
  },
  computed: {
    ...mapGetters(['getIsLoading']),
  },
  watch: {
    // eslint-disable-next-line func-names
    inside(item) {
      this.productMatObj = item
    },
  },
  methods: {
    inside(item) {
      this.productMatObj = item
    },
    getON(id) {
      this.orderNumber = id
    },
  },
}
</script>

<style scoped lang="scss">
 @media screen and (max-width: 1190px) {
  .main {
    padding: 90px 0.75rem 0 0.75rem;
    justify-content: center;
  }
 }
 @media screen and (max-width: 780px) {
  .main {
    .flex {
      flex-direction: column;
      .color-listing__wrapper {
        margin-left: 0;
      }
    }
  }
 }
</style>
